// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__MjqG-","additionalInfo":"AgreementModal_additionalInfo__aZ3Kh"};